import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Output } from '@angular/core';

@Component({
  selector: 'main-nav-message-center',
  templateUrl: './main-nav-message-center.component.html',
  styleUrls: ['./main-nav-message-center.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavMessageCenterComponent {
  @Output() messageCenterStatus = new EventEmitter();
  menuOpen = false;
  areNewMessages = false;

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    this.areNewMessages = !this.areNewMessages;
    //This will be better implemented in the integrations services.
    this.messageCenterStatus.emit({
      newMessages: this.areNewMessages
    })
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
  
    if (
      !target.closest('.message-center-icon') &&
      !target.closest('.message-center-trigger') &&
      !target.closest('.message-center-container__dropdown')
    ) {
      this.menuOpen = false;
    }
  }
}